import React from 'react';
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ListItemIcon from "@mui/material/ListItemIcon";
import Send from "@mui/icons-material/Send";
import ContentCopy from "@mui/icons-material/ContentCopy";
import Share from "@mui/icons-material/Share";
import ListItemText from "@mui/material/ListItemText";
import {useFeedbackTools} from "../../../../components/FeedbackTools";
import {useSendOnlineCheckInEmail} from "../../query";


// Menu component
const GuestsMenu = ({booking}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const {askConfirmation} = useFeedbackTools();
    const sendOnlineCheckInEmail = useSendOnlineCheckInEmail();

    const shareEnabled = !!navigator.share;
    const clipBoardEnabled = !!navigator.clipboard;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const sendCheckInOnlineEmail = async () => {
        await sendOnlineCheckInEmail.mutateAsync({bookingId: booking.id});
    }

    const handleSendEmail = () => {
        handleClose();

        askConfirmation({
            title: "Invia email per il check in online",
            description: `Confermi di voler inviare l'email per il check in online all'ospite?`,
            confirmationText: 'Si',
            cancellationText: 'No',
            onConfirm: sendCheckInOnlineEmail
        });
    }

    const handleCopyLink = () => {
        handleClose();
        if (clipBoardEnabled) {
            navigator.clipboard.writeText(booking.getCheckInOnlineUrl())
        }
    }

    const handleShareLink = () => {
        handleClose();
        if (shareEnabled) {
            navigator.share({url: booking.getCheckInOnlineUrl()})
        }
    }

    return (
        <Box>
            <IconButton
                aria-controls="online-check-in-action-menu"
                aria-haspopup="true"
                edge="end"
                aria-label="comments"
                onClick={handleClick}>
                <MoreVertIcon/>
            </IconButton>
            <Menu
                id="online-check-in-action-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}>

                <MenuItem onClick={handleSendEmail} disabled={booking.isOnlineCheckInDone() || !booking.email}>
                    <ListItemIcon>
                        <Send fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Invia email di check in all'ospite</ListItemText>
                </MenuItem>

                {
                    clipBoardEnabled &&
                    <MenuItem onClick={handleCopyLink}>
                        <ListItemIcon>
                            <ContentCopy fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText>Copia link check in</ListItemText>
                    </MenuItem>
                }

                {
                    shareEnabled &&
                    <MenuItem onClick={handleShareLink}>
                        <ListItemIcon>
                            <Share fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText>Condividi link check in con l'ospite</ListItemText>
                    </MenuItem>
                }
            </Menu>
        </Box>
    );
}

GuestsMenu.propTypes = {
    booking: PropTypes.object.isRequired,
}

export default GuestsMenu;